  document.addEventListener('DOMContentLoaded', function() {
    
    document.querySelectorAll('.favourite_button').forEach(button => {
      button.addEventListener('click', function(event) {
        const producthandle = button.getAttribute('data-product-handle');
        addToWishlist(producthandle, button);
     });
    });

    let _wished_products_handles = [];
    if ($.cookie("wishlist")) {
      _wished_products_handles = $.cookie("wishlist").split(",");
    }

    
    // Initialize the wishlist from cookies if available
    // document.cookie = "wishlist=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    var wishlistCookie = document.cookie.split('; ').find(row => row.startsWith('wishlist='));
    console.log('wishlistCookie', wishlistCookie);
        
    if (wishlistCookie)
    {
      _wished_products_handles = wishlistCookie.split('=')[1].split(',');
      
      document.querySelectorAll('.favourite_button').forEach(button => {
        const productHandle = button.getAttribute('data-handle');

        if (_wished_products_handles.includes(productHandle)) {
          button.querySelector('.fav_img').src = 'https://cdn.shopify.com/s/files/1/0696/6329/3657/files/favourite.png?v=1718372704';
        }
        else {
          button.querySelector('.fav_img').src = 'https://cdn.shopify.com/s/files/1/0696/6329/3657/files/not_favourite.png?v=1718372704';
        }
      });
    }
    

    // Function to handle adding product to wishlist
    function addToWishlist(productHandle, button) {

      if (!_wished_products_handles.includes(productHandle)) {
        console.log('Product added to wishlist:', productHandle);
        
        _wished_products_handles.push(productHandle);
        button.querySelector('.fav_img').src = 'https://cdn.shopify.com/s/files/1/0696/6329/3657/files/favourite.png?v=1718372704';
        updateWishlistCookie(_wished_products_handles);
        
        console.log('added_wished_products_handles', _wished_products_handles);
      }
      else {
        removeFromWishlist(productHandle, button);
      }
    }

    
    // Attach event listeners to all favourite buttons
    document.querySelectorAll('.favourite_button').forEach(button => {
      button.addEventListener('click', function(event) {
        // const productHandle = button.getAttribute('data-handle');
        // addToWishlist(productHandle, button);
      });
    });

    function removeFromWishlist(productHandle, button) {
  
      if (_wished_products_handles.includes(productHandle)) {
        
        // Remove the product handle from the wishlist array
        _wished_products_handles = _wished_products_handles.filter(item => item !== productHandle);
        button.querySelector('.fav_img').src = 'https://cdn.shopify.com/s/files/1/0696/6329/3657/files/not_favourite.png?v=1718372704';
        
        console.log('Removing product from wishlist:', productHandle);
        updateWishlistCookie(_wished_products_handles);

        console.log('removed_wished_products_handles', _wished_products_handles);
      }
    }

    function updateWishlistCookie(wishlist) {
      document.cookie = `wishlist=${wishlist.join(',')}; path=/`;
    }
  });